<!--
	<div *ngIf="handlerType.chat" class="btn-asistente bg-brand">
  <div *ngIf="handlerType.chat" id="chat-circle" class="btn btn-raised tooltip" >
    <div id="chat-overlay"></div>
      <span class="tooltiptext">Chat con asesor</span>
    <img src="assets/images/icono-asistente-chat.svg" (click)="onClickRenderComponent('chat')">
  </div>
  <div *ngIf="handlerType.chat && handlerType.email" class="separador"></div>
  </div>
  <div *ngIf="handlerType.email || handlerType.both" class="btn-asistente bg-brand">
    <div *ngIf="handlerType.email" id="email-circle" class="btn btn-raised tooltip" >
      <div id="email-overlay"></div>
        <span class="tooltiptext" >¿Necesitas ayuda?</span>
      <img src="assets/images/icono-asistente.svg"  (click)="onClickRenderComponent('email')">
    </div>
  </div>
  -->
<div *ngIf="handlerType.chat || handlerType.email || handlerType.both || handlerType.menuArbol" >
  <!-- CHAT -->
  <app-boton-flotante *ngIf="handlerType.chat" title="Chat con asesor" (click)="onClickRenderComponent('chat')"
    class="btn-asistente"
    icono="assets/images/basecomponents-images/icono-asistente-normalizado.svg"></app-boton-flotante>

  <!-- MAIL -->
  <app-boton-flotante *ngIf="handlerType.email" title="¿Necesita ayuda?" (click)="onClickRenderComponent('email')"
    class="btn-asistente"
    icono="assets/images/basecomponents-images/icono-asistente-normalizado.svg"></app-boton-flotante>

  <!-- MENÚ -->
  <app-boton-flotante *ngIf="handlerType.menuArbol" title="¿Necesita ayuda?"
    (click)="onClickRenderComponent('menuArbol')" class="btn-asistente"
    icono="assets/images/basecomponents-images/icono-asistente-normalizado.svg"></app-boton-flotante>
  <!-- <div *ngIf="handlerType.chat || handlerType.email || handlerType.both" class="btn-asistente bg-brand">
  <div *ngIf="handlerType.chat" id="chat-circle" class="btn btn-raised tooltip">
      <div id="chat-overlay"></div>
      <span class="tooltiptext">Chat con asesor</span>
      <img src="assets/images/icono-asistente-chat.svg" (click)="onClickRenderComponent('chat')">
    </div> 
    <div *ngIf="handlerType.chat && handlerType.email" class="separador"></div>
    <div *ngIf="handlerType.email" id="email-circle" class="btn btn-raised tooltip">
      <div id="email-overlay"></div>
      <span class="tooltiptext">¿Necesita ayuda?</span>
      <img src="assets/images/contact-mail.svg" (click)="onClickRenderComponent('email')">
    </div>
  </div> -->

</div>
<!-- <div *ngIf="handlerType.chat || handlerType.email || handlerType.both || handlerType.menuArbol"
  class="btn-asistente bg-brand">
  <div *ngIf="handlerType.chat" id="chat-circle" class="btn btn-raised tooltip">
    <div id="chat-overlay"></div>
    <span class="tooltiptext">Chat con asesor</span>
    <img src="assets/images/icono-asistente-chat.svg" (click)="onClickRenderComponent('chat')">
  </div>
  <div *ngIf="handlerType.chat && handlerType.email" class="separador"></div>
  <div *ngIf="handlerType.email" id="email-circle" class="btn btn-raised tooltip">
    <div id="email-overlay"></div>
    <span class="tooltiptext">¿Necesita ayuda?</span>
    <img src="assets/images/contact-mail.svg" (click)="onClickRenderComponent('email')">
  </div>
  <div *ngIf="handlerType.menuArbol" id="menu-arbol-circle" class="btn btn-raised tooltip">
    <div id="menu-arbol-overlay"></div>
    <span class="tooltiptext">¿Necesita ayuda?</span>
    <img src="assets/images/icono-asistente.svg" (click)="onClickRenderComponent('menuArbol')">
  </div>
  <div *ngIf="handlerType.chat && handlerType.email && handlerType.menuArbol" class="separador"></div>
</div> -->